import { render } from "./ConfirmPage.vue?vue&type=template&id=4ee45da3&scoped=true"
import script from "./ConfirmPage.vue?vue&type=script&lang=js"
export * from "./ConfirmPage.vue?vue&type=script&lang=js"

import "./ConfirmPage.vue?vue&type=style&index=0&id=4ee45da3&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee45da3"]])

export default __exports__